import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Photos extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">


          <div className="new_banner">
            <div className="banner_content">
              <h1>CSCI 2023</h1>
              <h6>The 2023 International Conference on</h6>
              <h6>Computational Science and Computational Intelligence (CSCI)</h6>
              <h6>December 13-15, 2023, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
          
          <h4 className="par_header">CSCI 2023</h4>
            <div className="par">
                <div className="pic_wrapper_gal">
                    <img src="/static/CSCI23B.jpg"></img>
                    <br/>
                <a target="_blank" href="https://photos.app.goo.gl/VuW3btBgGA8kDmFu8">View More</a>
                </div>
                <br />
            </div>

          <h4 className="par_header">CSCI 2022</h4>
            <div className="par">
                <div className="pic_wrapper_gal">
                    <img src="/static/csci22.JPG"></img>
                    <br/>
                <a target="_blank" href="https://photos.app.goo.gl/JecPgJPkeK1SxC9F6">View More</a>
                </div>
            </div>
          
          <h4 className="par_header">CSCI 2021</h4>
            <div className="par">
                <div className="pic_wrapper_gal">
                    <img src="/static/csci21.jpg"></img>
                    <br/>
                <a target="_blank" href="https://photos.app.goo.gl/Qgo1JkUUqThhcGXt6">View More</a>
                </div>
            </div>
            
        <h4 className="par_header">Past Events</h4>
            <div className="par">
                <div className="pic_wrapper_gal">
                    <img src="/static/past_evs.jpg"></img>
                    <br/>
                <a target="_blank" href="https://www.american-cse.org/csce2023/gallery">View More</a>
                </div>
            </div>
            
          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Photos;